// extracted by mini-css-extract-plugin
export var externalLink = "_9a-0";
export var internalLinkLabel = "_9a-1";